import { styled } from '../../Styles/stitches.config'
import { default as Svg } from 'react-inlinesvg'

export const StyledSVG = styled(Svg, {
    display: 'inline-block',
    height: '1em',
    overflow: 'visible',
})
